import React, { useEffect, useState } from "react";
import s from "./NewRoleForm.module.scss";
import { SubmitHandler, useForm } from "react-hook-form";
import {
  parseClientError,
  swrFetcher,
  swrMutationFetcher,
  SwrMutationFetcherArgType,
} from "../../../../../../libs/api/Endpoints";
import clsx from "clsx";
import { Button } from "antd";
import { teamPermission } from "../../../../../../libs/Utils/Types/Teams";
import { UseAuthToken } from "../../../../../../libs/api/userSession";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { SuccessDataType } from "../../../../../../libs/api/types";
import { generateResult } from "../../../../../../global components/ResultModal/ResultModal";
import Unauthorised from "../../../../../../global components/Unauthorised";
import { ThreeDots } from "react-loader-spinner";
type Inputs = {
  role: string;
};
type AddContactProp = {
  handleOpen: () => void;
  groupID?: string | null;
  mutate: () => void;
};
type newRole = {
  title: string;
  permissions: string[];
};
function NewRoleForm({ handleOpen }: AddContactProp) {
  const [newsUpdates, setNewsUpdates] = useState<string[]>([]);
  const [permissionUnauthorized, setPermissopnUnauthorized] = useState<
    boolean | { title: string; message: string }
  >(false);
  const token = UseAuthToken();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<Inputs>({ shouldFocusError: false });
  const {
    data: permissions,
    isLoading,
    error,
    mutate,
  } = useSWR<{data:teamPermission}, any, any>(
    token ? ["api/admin/team/permissions", token] : null,
    swrFetcher,
    {
      revalidateOnFocus: true,
      shouldRetryOnError: false, // Disable retrying on errors
    }
  );

  const { trigger: createNewRole, isMutating } = useSWRMutation(
    `api/admin/team/roles`,
    swrMutationFetcher
  );
  const handleNewsUpdatesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target;

    setNewsUpdates((prev) => {
      if (checked) {
        // Add the id to the list if it's checked
        return [...prev, id];
      } else {
        // Remove the id from the list if it's unchecked
        return prev.filter((item) => item !== id);
      }
    });
  };

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    const jsonBody = { title: data.role, permissions: newsUpdates };

    try {
      if (token) {
        const fetchArg: SwrMutationFetcherArgType = {
          token: token,
          requestOption: {
            method: "post",
            body: JSON.stringify(jsonBody),
            headers: {
              "Content-Type": "application/json",
            },
          },
        };
        const result: SuccessDataType<newRole> = await createNewRole(fetchArg);
        handleOpen();
        generateResult(
          "success",
          result.message.charAt(0).toUpperCase() + result.message.slice(1)
        );
        mutate && mutate();
        reset();
      }
    } catch (error: any) {
      const e = parseClientError(error);
      generateResult("error", e.message || e.error);
      console.error(e);
    }
  };
  const permission =
    permissions?.data.map((permission) => (
      <div className={s.input} key={permission.id}>
        <input
          type="checkbox"
          id={permission.id}
          //checked={newsUpdates[permission.name.toLowerCase()] || false} // Dynamically bind state
          onChange={handleNewsUpdatesChange}
        />
        <label htmlFor={permission.id}>{permission.name}</label>
      </div>
    )) || null;
  useEffect(() => {
    if (error) {
      const e = parseClientError(error);
      if (e.statusCode === 403) {
        setPermissopnUnauthorized(true);
      } else {
        setPermissopnUnauthorized({
          title: "Error!",
          message: e.message || "Something went wrong",
        });
      }
    }
  }, [error]);
  return isLoading ? (
    <div className={s.spin}>
      <ThreeDots
        visible={true}
        height="50"
        width="50"
        color="#d52b1e"
        radius="9"
        ariaLabel="three-dots-loading"
        wrapperStyle={{
          dispaly: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
        wrapperClass=""
      />
    </div>
  ) : permissionUnauthorized ? (
    typeof permissionUnauthorized === "boolean" ? (
      <div className={s.spin}>
        <Unauthorised />
      </div>
    ) : (
      <div className={s.spin}>
        <Unauthorised error={permissionUnauthorized} />
      </div>
    )
  ) : (
    <div className={s.wrapper}>
      <form className={s.form}>
        <div className={clsx(s.inputWrapper)}>
          <label htmlFor="role" className={clsx(s.inputLabel)}>
            Role title
          </label>
          <input
            id="role"
            className={clsx(s.input, { [s.inputError]: errors.role })}
            {...register("role")}
          />
          {errors.role && (
            <span className={clsx(s.errorMessage)}>{errors.role.message}</span>
          )}
        </div>
        <div className={s.inputs}>
          <span className={s.rolePermission}>Role permission</span>
          {permission}
        </div>
      </form>
      <div className={s.addContactBtns}>
        <Button
          type="default"
          className={clsx(s.button, s.cancelBtn)}
          onClick={handleOpen}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          className={clsx(s.button, s.addContactBtn)}
          htmlType="submit"
          loading={isMutating}
          disabled={isMutating}
          onClick={handleSubmit(onSubmit)}
        >
          Create role
        </Button>
      </div>
    </div>
  );
}

export default NewRoleForm;
